import React from 'react';
import FlemishHeader from '../Headers/FlemishHeader';
import MainHeader from '../Headers/MainHeader';
import FlemishFooter from '../Footers/FlemishFooter';
import favicon from '../../images/favicon.ico';
import { Helmet } from 'react-helmet';

export default function Layout({ children }): React.JSX.Element {
  return (
    <>
      <Helmet>
        <link rel="icon" href={favicon} sizes="16x16" />
      </Helmet>

      <header>
        <FlemishHeader />
        <MainHeader />
      </header>

      <main>
        <div className="vl-region">
          <div className="vl-layout">
            <div className="vl-grid vl-grid--is-stacked">
              <div className="vl-col--1-1">{children}</div>
            </div>
          </div>
        </div>
      </main>

      <footer>
        <FlemishFooter />
      </footer>
    </>
  );
}
